/* Scroll interactions: hero color-reveal + tile slide-in
   Non-invasive: only touches elements via existing theme classes.
   Tiles already inside the viewport at load are left fully visible
   (no animation, no LCP delay) — only off-screen tiles are hidden
   and animated in when the user scrolls to them. */
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  /* ---------- Hero color-reveal on scroll ---------- */
  function updateHeroReveal() {
    var heroes = document.querySelectorAll('.hero');
    var vh = window.innerHeight;
    for (var i = 0; i < heroes.length; i++) {
      var hero = heroes[i];
      var rect = hero.getBoundingClientRect();
      var total = rect.height || 1;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var progress = scrolled / total;
      if (rect.bottom > -vh && rect.top < vh * 2) {
        hero.style.setProperty('--scroll-reveal-grayscale', 1 - progress);
      }
    }
  }

  var heroTicking = false;
  function onScrollHero() {
    if (heroTicking) return;
    heroTicking = true;
    window.requestAnimationFrame(function () {
      updateHeroReveal();
      heroTicking = false;
    });
  }

  /* ---------- Category / product tiles slide-in on scroll ---------- */
  function initTileReveal() {
    var containers = document.querySelectorAll(
      '.collection-links__container, .resource-list--grid'
    );
    if (!containers.length) return;

    var vh = window.innerHeight;
    var toObserve = [];

    containers.forEach(function (container) {
      Array.prototype.forEach.call(container.children, function (tile) {
        if (tile.dataset.revealChecked) return;
        tile.dataset.revealChecked = 'true';

        var rect = tile.getBoundingClientRect();
        var alreadyInView = rect.top < vh && rect.bottom > 0;

        if (alreadyInView) {
          return;
        }

        tile.classList.add('scroll-reveal-pending');
        toObserve.push(tile);
      });
    });

    if (!toObserve.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    toObserve.forEach(function (tile) {
      observer.observe(tile);
    });
  }

  function init() {
    updateHeroReveal();
    window.addEventListener('scroll', onScrollHero, { passive: true });
    window.addEventListener('resize', onScrollHero, { passive: true });
    initTileReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
